import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
export default {
  name: "AddComplain",
  components: {},
  props: ["prorData"],
  data: function data() {
    return {
      show: false,
      loading: false,
      title: "",
      fileUploadData: {
        folderId: "aa"
      },
      // uploadUrl: this.$http.defaults.baseURL + "/file/upload", // 上传地址
      uploadHeader: {},
      form: {
        title: "",
        con: "",
        fileList: [],
        state: false
      },
      rules: {
        title: [{
          required: true,
          message: "请输入标题",
          trigger: "blur"
        }],
        con: [{
          required: true,
          message: "请输入内容",
          trigger: "blur"
        }],
        fileList: [{
          required: true,
          message: "请上传附件",
          trigger: "blur"
        }]
      }
    };
  },
  computed: _objectSpread({}, mapGetters(["userToken", "userData"])),
  created: function created() {},
  mounted: function mounted() {
    this.uploadHeader = {
      token: this.userToken
    };
  },
  destroyed: function destroyed() {},
  methods: {
    // 显示弹框
    dialogShow: function dialogShow() {
      // 重置表单、显示弹框
      this.show = true;
      this.$nextTick(function () {
        this.$refs["ruleForm"].resetFields();
        this.title = "新增建议";
      });
    },
    // 确定提交
    submitForm: function submitForm(formName) {
      var _this = this;

      this.loading = true;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$refs.fileUpload.submit(); // 上传附件

        } else {
          _this.loading = false;
          return false;
        }
      });
    },
    // 新增 提交方法
    submitFn: function submitFn(id) {
      var _this2 = this;

      var data = {
        title: this.form.title,
        content: this.form.con,
        fileId: id,
        userName: this.form.state ? "匿名" : this.userData.userName
      };

      if (!id) {
        this.loading = false;
        this.form.fileList = [];
        this.$message.error("附件上传失败，请重新选择附件！");
        return;
      }

      this.$http.post("/complaint/add", data).then(function (_ref) {
        var data = _ref.data;

        if (data.resCode === 0) {
          _this2.$message.success("投诉内容新增成功！");
        }

        _this2.loading = false;
        _this2.show = false;
      }).catch(function () {
        _this2.show = false;
        _this2.loading = false;

        _this2.$message.error("网络错误！");
      });
    },
    // 上传附件
    fileChange: function fileChange(file, fileList) {
      var isJPG = file.raw.type === "text/plain" || file.raw.type === "application/vnd.ms-excel" || file.raw.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      var isLt2M = file.size / 1024 < 1024;
      var isSize = file.size;

      if (!isSize) {
        this.$refs.fileUpload.clearFiles();
        this.$message.error("该文件内容为空，请重新选择。");
        return;
      }

      if (!isJPG) {
        this.$refs.fileUpload.clearFiles();
        this.$message.error("上传文件只能是 .txt, .docx, .xls 格式文件!");
        return;
      }

      if (!isLt2M) {
        this.$refs.fileUpload.clearFiles();
        this.$message.error("上传文件大小不能超过 1MB!,请重新上传。");
        return;
      }

      this.form.fileList = fileList;
    },
    // 上传成功
    fileSuccess: function fileSuccess(response, file) {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.submitFn(response.resData);
      });
    },
    // 移除文件
    fileRemove: function fileRemove(file) {
      this.form.fileList = [];
      this.$message.success("文件 " + file.name + " 移除成功！");
    },
    // 文件移除提示
    fileBeforeRemove: function fileBeforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    handleExceed: function handleExceed() {
      this.$message.warning("只支持上传 1 个文件");
    }
  },
  watch: {},
  filters: {}
};